import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useSubscription } from '../../../hooks/useSubscription';
import { getTierDisplayName } from '../../../config/featureAccess';

const AccountSettings = ({ userProfile, onSave }) => {
  const [fullName, setFullName] = useState(userProfile?.name || '');
  const [email, setEmail] = useState(userProfile?.email || '');
  const { tier, ugcTier, subscription } = useSubscription();

  const handleSaveProfile = () => {
    onSave({ 
      type: 'profile',
      data: { fullName, email } 
    });
  };

  const tierLabel = getTierDisplayName(tier);
  const ugcTierLabel = ugcTier && ugcTier !== 'free' ? getTierDisplayName(ugcTier) : null;
  const statusLabel = subscription?.status === 'active' ? 'Active' : 'Inactive';
  const renewalText = subscription?.cancelAtPeriodEnd
    ? 'Cancels at period end'
    : 'Renews automatically';

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="User" size={18} color="var(--color-primary)" />
          Profile Information
        </h3>
        
        <Input
          type="text"
          label="Full Name"
          value={fullName}
          onChange={(e) => setFullName(e?.target?.value)}
          placeholder="Enter your full name"
        />

        <Input
          type="email"
          label="Email Address"
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          placeholder="Enter your email"
          description="Used for login and coaching notifications"
        />

        <Button 
          variant="default" 
          onClick={handleSaveProfile}
          iconName="Save"
          iconPosition="left"
        >
          Save Profile Changes
        </Button>
      </div>
      <div className="h-px bg-border" />
      <div className="space-y-4">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="Crown" size={18} color="var(--color-primary)" />
          Subscription
        </h3>

        <div className="bg-accent/10 rounded-lg p-4 border border-accent/20">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Sparkles" size={20} className="text-primary" />
            </div>
            <div className="text-sm space-y-1">
              <p className="font-medium text-foreground">Current tier: <span className="text-primary font-semibold">{tierLabel}</span></p>
              <p className="text-muted-foreground">Status: {statusLabel}</p>
              <p className="text-xs text-muted-foreground">{renewalText}</p>
              {ugcTierLabel && (
                <p className="text-xs text-muted-foreground">
                  UGC: <span className="font-semibold text-amber-700">{ugcTierLabel}</span>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
